import React from 'react';
import Button from '../../Button';
import Popup from '../../Popup';
import DefaultPicture from '../../../components/01_atoms/DefaultPicture';
import { DefaultPictureType } from '../../../types';

import s from './index.module.scss';

type SantaLetterUpsellModalType = {
  title?: string;
  description?: string;
  buttonLabel?: string;
  image?: DefaultPictureType;
  upsellButtonLabel?: string;
  upsellProductId: number;
  addProductToBasket: () => void;
  addUpsellProductToBasket: () => void;
};

const SantaLetterUpsellModal = ({
  title = '',
  description = '',
  buttonLabel = '',
  upsellButtonLabel = '',
  image = undefined,
  addProductToBasket,
  addUpsellProductToBasket,
}: SantaLetterUpsellModalType) => (
  <Popup
    closeButton={<></>}
    isOpen={true}
    shouldCloseOnOverlayClick={false}
    overlayClassName={s['santa-letter-upsell-modal']}
    data-component="santa-letter-upsell-modal"
  >
    <div className={s['santa-letter-upsell-modal__container']}>
      <div className={s['santa-letter-upsell-modal__block']}>
        <div className={s['santa-letter-upsell-modal__content']}>
          {title && <div className={s['santa-letter-upsell-modal__title']}>{title}</div>}
          {description && (
            <div className={s['santa-letter-upsell-modal__description']}>{description}</div>
          )}
          <Button
            buttonType="button"
            type="xmas"
            isMobileBlock
            onClick={addUpsellProductToBasket}
            className={s['santa-letter-upsell-modal__upsell-button']}
            data-button-type="primary"
          >
            {upsellButtonLabel}
          </Button>

          <Button
            buttonType="button"
            type="xmas"
            isOutlined
            isMobileBlock
            onClick={addProductToBasket}
            className={s['santa-letter-upsell-modal__button']}
            data-button-type="secondary"
          >
            {buttonLabel}
          </Button>
        </div>
        {image && (
          <div className={s['santa-letter-upsell-modal__image']}>
            <DefaultPicture {...image} />{' '}
          </div>
        )}
      </div>
    </div>
  </Popup>
);

export default SantaLetterUpsellModal;
